export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only z-[100] focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:rounded-md focus:bg-(--color-primary) focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-(--color-primary-foreground) focus:shadow-lg"
    >
      Skip to main content
    </a>
  );
}
